import BaseModel from './BaseModel';

/** Class representing a distributor. */
class Distributor extends BaseModel {}

export default Distributor;
